import type { ApplicationDocumentTypeEnum } from '@acme/api';
import { Icon } from '@acme/assets';
import type { FilterOption } from '@acme/foundation';
import { FilterDropdown, Input } from '@acme/foundation';
import { useMemo } from 'react';
import type {
  ApplicationDocumentsFiltersValue,
  DocumentDatePeriod,
} from '../../lib/filtertypes';

const ALL_DOCUMENT_TYPES = 0;

const periodOptions: FilterOption<DocumentDatePeriod>[] = [
  { value: 'all', label: 'Все время' },
  { value: '7d', label: '7 дней' },
  { value: '30d', label: '30 дней' },
];

export type ApplicationDocumentsFiltersProps = {
  value: ApplicationDocumentsFiltersValue;
  onChange: (next: ApplicationDocumentsFiltersValue) => void;
  documentTypeOptions: Array<{
    value: ApplicationDocumentTypeEnum;
    label: string;
  }>;
  className?: string;
};

export const ApplicationDocumentsFilters = ({
  value,
  onChange,
  documentTypeOptions,
  className = '',
}: ApplicationDocumentsFiltersProps) => {
  const optionsWithAll = useMemo(
    () => [
      { value: ALL_DOCUMENT_TYPES as number, label: 'Все' },
      ...documentTypeOptions.map((o) => ({
        value: o.value as number,
        label: o.label,
      })),
    ],
    [documentTypeOptions]
  );

  const documentTypeValue = value.documentTypeId ?? ALL_DOCUMENT_TYPES;

  return (
    <div
      className={`flex flex-wrap justify-between items-center gap-3 ${className}`}
    >
      <div className="flex items-center gap-3">
        <FilterDropdown<number>
          title="Тип документа"
          value={documentTypeValue}
          options={optionsWithAll}
          onChange={(v) =>
            onChange({
              ...value,
              documentTypeId:
                v === ALL_DOCUMENT_TYPES || v === undefined
                  ? undefined
                  : (v as ApplicationDocumentTypeEnum),
            })
          }
        />
        <FilterDropdown
          title="Период"
          value={value.period}
          options={periodOptions}
          onChange={(period) => onChange({ ...value, period: period ?? 'all' })}
        />
      </div>
      <div>
        <Input
          value={value.search}
          onChange={(search) => onChange({ ...value, search })}
          placeholder="Поиск по названию или заявке…"
          leftIcon={<Icon name="search-outline" size={16} />}
          className="w-full sm:w-80"
        />
      </div>
    </div>
  );
};
